import React, { ChangeEvent, Dispatch, SetStateAction, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import Strings from "@my-dld/assets/strings";
import PageTitle from "@my-dld/components/PageTitle";
import { DashboardBCItem, LeaseDetailsBCItem } from "@my-dld/contexts/PageContext";
import PageContent from "@my-dld/components/PageContent";
import { extractPropInfo } from "../component/PropertyHeader";
import { Redirect, Route } from "react-router";
import FormMandatory from "../component/FormMandatory";
import { EIDModal } from "@my-dld/screens/Login/owner/EID";
import { ServerDate, StringUtil } from "@eres/core";
import EidInputField from "@eres/forms-web/EidInputField";
import DateInputField from "@eres/forms-web/DateInputField";
import { FormHolder, NullableFormValue } from "@eres/forms";
import eidConverter from "@eres/forms/converters/EidConverter";
import { getError, hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { CoOccupant, CoOccupantPropertyInfo, CoOccupantSearchInfo } from "@eres/ejari-api/Entity/co_occupants";
import { EjariApi } from "@eres/ejari-api";
import { AppContext } from "@my-dld/contexts/AppContext";
import { getEjariActiveUserId, getEjariUserType, getParticipantID } from "@10x/sso";
import Popup from "@my-dld/components/Popup/Popup";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import _ from "lodash";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { getEjariPropertyId } from "@eres/ejari-api/Utils";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import { COHeader, CORow } from "../component/CoOccupant/CoOccupants";
import COContext, { COContextWrapper } from "@my-dld/contexts/COContext";
import { History } from "history";
import { PropertyCoOccupantContractType } from "@eres/ejari-api/api";
import { TenantContext } from "@eres/ejari-core/contexts/TenantContext";
import { extractPropInfo as extractTabuPropInfo, getSelectedProperty } from "@my-dld/screens/MyDLD/PropertyDetails";
import { EjariContext } from "@eres/ejari-core/contexts/EjariContext";
import RadioInputField from "@eres/forms-web/RadioInputField";
import { YES, YesNo } from "@10x/handtakeover/api/entities";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import { Lookup } from "@eres/ejari-api/Entity";
import TextInputField from "@eres/forms-web/TextInputField";
import NumberConverter from "@eres/forms/converters/NumberConverter";
import { navigateWithInParent } from "@my-dld/utils/StoreUtils";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";

export function PropertyCoOccupants( props: RoutedViewProps ) {
	let { history, match } = props;
	const propertyId = match.params.propertyId;
	const propertyTypeId = match.params.propertyTypeId;
	const isFreeHold = match.params.isFreeHold;
	const info = useMemo( () => {
		return {
			ActiveUserID: getEjariActiveUserId(),
			ContractId: 0,
			ContractType: PropertyCoOccupantContractType,
			ActiveUserType: getEjariUserType(),
			EjariPropertyId: [],
			PropertyDetails: {
				PropertyId: Number( propertyId ),
				PropertyTypeId: Number( propertyTypeId ),
				IsFreeHold: isFreeHold === "true",
				OwnerId: getParticipantID(),
			},
		} as CoOccupantPropertyInfo;
	}, [ propertyId, propertyTypeId, isFreeHold ] );

	const propertyTitle = useCallback( () => {
		let property = getSelectedProperty( props.match.params );
		if ( property ) {
			let { val, lbl } = extractTabuPropInfo( property );
			return " - " + lbl + " : " + val;
		}
		return "";
	}, [] );
	const pp = props.match.url;
	return <COContextWrapper mode={ "property" } info={ info } propertyTitle={ propertyTitle }>
		<Route path={ pp } exact={ true } component={ CoOccupantCount }/>
		<Route path={ pp + "/details" } component={ ManageCoOccupant }/>
	</COContextWrapper>;
}


export function EjariPropertyCoOccupants( props: RoutedViewProps ) {
	let { history, match } = props;
	const tx = useContext( EjariContext );
	const property = tx.property;
	const info = useMemo( () => {
		return {
			ActiveUserID: getEjariActiveUserId(),
			ContractId: 0,
			ContractType: PropertyCoOccupantContractType,
			ActiveUserType: getEjariUserType(),
			EjariPropertyId: [],
			PropertyDetails: {
				PropertyId: Number( property?.TabuPropertyId ),
				PropertyTypeId: Number( property?.PropertyTypeId ),
				IsFreeHold: property?.IsFreeHold,
				OwnerId: getParticipantID(),
			},
		} as CoOccupantPropertyInfo;
	}, [ property ] );

	const propertyTitle = useCallback( () => {
		if ( property ) {
			let { val, lbl } = extractPropInfo( property );
			return " - " + lbl + " : " + val;
		}
		return "";
	}, [ property ] );
	const pp = props.match.url;
	return <COContextWrapper mode={ "property" } info={ info } propertyTitle={ propertyTitle }>
		<Route path={ pp } exact={ true } component={ CoOccupantCount }/>
		<Route path={ pp + "/details" } component={ ManageCoOccupant }/>
	</COContextWrapper>;
}

export function TenantCoOccupants( props: RoutedViewProps ) {
	let { history } = props;
	const tx = useContext( TenantContext );
	const property = tx.property;
	const info = useMemo( () => {
		const ep = Number( getEjariPropertyId( property! ) );
		let { ContractId, ContractTypeId } = property?.CurrentContract!;
		return {
			ActiveUserID: getEjariActiveUserId(),
			ContractId: ContractId!,
			ContractType: ContractTypeId!,
			ActiveUserType: getEjariUserType(),
			EjariPropertyId: [
				ep,
			]
		};
	}, [ property ] );
	const propertyTitle = useCallback( () => {
		if ( property ) {

			let { val, lbl } = extractPropInfo( property );
			return " - " + lbl + " : " + val;
		} else return "";
	}, [ property ] );
	const pp = props.match.url;
	return <COContextWrapper mode={ "contract" } info={ info } propertyTitle={ propertyTitle }>
		<Route path={ pp } exact={ true } component={ CoOccupantCount }/>
		<Route path={ pp + "/details" } component={ ManageCoOccupant }/>
	</COContextWrapper>;
}

function CoOccupantPage( props: React.PropsWithChildren<any> ) {
	const { children } = props;
	const tx = useContext( COContext );
	const isPropertyMode = tx.mode === "property";
	const bcs = useMemo( () => {
		if ( isPropertyMode ) return [ DashboardBCItem ];
		return [ DashboardBCItem, LeaseDetailsBCItem ];
	}, [ isPropertyMode ] );
	const getString = tx.getString;
	return <PageContent
		hideQLinks={ true }
		title={ getString( "manage_co_occupants" ) + tx.propertyTitle?.() }
	>
		<PageTitle title={ getString( "manage_co_occupants" ) } paths={ bcs }/>
		{ children }
	</PageContent>;
}

export function CoOccupantCount( props: RoutedViewProps ) {
	const { history } = props;
	const [ data, setData ] = useState<{ count?: string }>( () => {
		return {};
	} );
	const holder = useDataHolder( data, setData );
	const tx = useContext( COContext );
	const info = tx.info;
	const isPropertyMode = tx.mode === "property";

	const [ oc, setOcs ] = useState<CoOccupant[]>( [] );
	const [ maxCount, setMaxCount ] = useState( 999 );
	const [ maxError, setMaxError ] = useState<undefined | string>( undefined );

	const updateCtx = useCallback( () => {
		let ContractTypeId = info.ContractType;
		let ContractId = info.ContractId;
		let api = () => EjariApi.getCoOccupants( ContractId!, ContractTypeId );
		if ( isPropertyMode ) {
			ContractId = info?.PropertyDetails?.PropertyId;
			api = () => EjariApi.getCoOccupants( ContractId!, ContractTypeId, info.PropertyDetails?.PropertyTypeId, info.PropertyDetails?.IsFreeHold );
		}
		if ( ContractId == null || ContractTypeId == null ) return;
		showLoading();
		api()
		.then( ocl => {
			hideLoading();
			setOcs( ocl.CoTenants );
			let c = ocl.TotalCoTenants;
			if ( c == null && ocl.CoTenants && ocl.CoTenants.length > 0 )
				c = ocl.CoTenants.length;
			setData( { count: c != null ? c + "" : "" } );
			const maxAllowed = ocl.AllowedCoTenants == null ? 999 : ocl.AllowedCoTenants;
			setMaxCount( maxAllowed );
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}, [] );
	useEffect( () => {
		updateCtx();
	}, [] );
	const c = data.count;
	useEffect( () => {
		if ( c != null ) {
			const n = Number( c );
			if ( n > maxCount ) {
				setMaxError( Strings.allowed_co_tenants.format( maxCount.toString() ) );
				return;
			}
		}
		setMaxError( undefined );
	}, [ c, maxCount ] );
	const onUpdate = useCallback( () => {
		const cv = data.count;
		if ( cv == null ) {
			showErrorMessage( Strings.please_enter_number_of_co_occupants );
			return;
		} else {
			showLoading();
			return EjariApi.updateCoOccupants( tx.info, oc, Number( cv ) )
			.then( r => {
				hideLoading();
				JQModal( "coOccupantCountUpdated" ).show();
				return r;
			} )
			.catch( e => {
				hideLoading();
				showErrorMessage( e );
			} );
		}
	}, [ data, oc, tx ] );
	const onCancel = useCallback( () => {
		JQModal( "coOccupantCountUpdated" ).hide();
		history.goBack();
	}, [ history ] );
	const onYes = useCallback( () => {
		navigateWithInParent( "cooccupants", "details" );
		JQModal( "coOccupantCountUpdated" ).hide();
	}, [] );
	return <CoOccupantPage>
		<div className="row">
			<div className="col-md-3">
				<TextInputField
					holder={ holder }
					required={ true }
					id={ "count" }
					error={ maxError }
					label={ Strings.enter_no_of_co_co_occupants }
					maxLength={ ( maxCount + "" ).length }
					valueConverter={ NumberConverter }/>
				<div className="form-group">
					<button
						onClick={ onUpdate } disabled={ !isEmptyStringOrNull( maxError ) }
						type="button" className="btn btn_style1 btn_1">
						{ Strings.submit }
					</button>
					<button
						onClick={ onCancel } type="button"
						className="btn btn-grey ms-2 me-2">{ Strings.cancel }</button>
				</div>
			</div>
		</div>
		<Popup
			id="coOccupantCountUpdated" title={ Strings.confirmation }
			showCloseButton={ true }
			clickOutsideToDismiss={ false }
			showIcon={ false }>
			<div>
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
                <p className="text-center mb-3">
					{ Strings.co_oc_number_updated }
                </p>
                <p className="text-center font-size13">
                    {Strings.co_oc_number_updated_q}
                </p>
			</div>
			<div className="text-center">
                <button type="button" className="btn btn-grey " data-bs-dismiss="modal" onClick={ onCancel }>
					{ Strings.no }
				</button>
                <button type="button" className="btn btn_1 ms-2 me-2" onClick={ onYes }>
					{ Strings.yes }
				</button>
			</div>
		</Popup>
	</CoOccupantPage>;
}

function ManageCoOccupant( props: { history: History } ) {
	const tx = useContext( COContext );
	const info = tx.info;
	const isPropertyMode = tx.mode === "property";
	// original co occupants
	const [ oc, setOcs ] = useState<CoOccupant[]>( [] );
	// runtime co occupants
	const [ occupants, setOccupants ] = useState<CoOccupant[]>( [] );
	// co occupant for deletion
	const [ doc, setDoc ] = useState<CoOccupant | undefined>( undefined );
	const [ count, setCount ] = useState<number>( 0 );

	useEffect( () => {
		let ContractTypeId = info.ContractType;
		let ContractId = info.ContractId;
		let api = () => EjariApi.getCoOccupants( ContractId!, ContractTypeId );
		if ( isPropertyMode ) {
			ContractId = info?.PropertyDetails?.PropertyId;
			api = () => EjariApi.getCoOccupants( ContractId!, ContractTypeId, info.PropertyDetails?.PropertyTypeId, info.PropertyDetails?.IsFreeHold );
		}
		if ( ContractId == null || ContractTypeId == null ) return;
		showLoading();
		api()
		.then( ocl => {
			hideLoading();
			setOcs( ocl.CoTenants ?? [] );
			setOccupants( ocl.CoTenants ?? [] );
			setCount( ocl.TotalCoTenants ?? 0 );
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	}, [ info, isPropertyMode ] );
	const onNewOccupant = ( nc: CoOccupant ) => {
		nc.IsTemp = true;
		nc.IsPrimary = false;
		const ncl = [
			...occupants,
			nc,
		];
		setOccupants( ncl );
	};
	const onOCDel = ( oc: CoOccupant ) => {
		setDoc( oc );
		JQModal( "del-co_tenant" ).show();

	};
	const updateEjari = ( ocs: CoOccupant[] ) => {
		showLoading();
		return EjariApi.updateCoOccupants( tx.info, ocs, count )
		.then( r => {
			hideLoading();
			return r;
		} )
		.catch( e => {
			hideLoading();
			showErrorMessage( e );
		} );
	};
	const trackAction = useCallback( ( action: string ) => {
		if ( isPropertyMode ) {
			trackEventWithData( "Ejari", "DelCoOccupant", { contractId: info.ContractId } );
		} else {
			const params: any = {};
			const pd = info.PropertyDetails;
			if ( pd ) {
				params.property = `${ pd.PropertyId }/${ pd.PropertyTypeId }/${ pd.IsFreeHold }`;
			}
			trackEventWithData( "PropertyCoOccupant", action, params );
		}
	}, [ isPropertyMode, info ] );
	const onDelConfirm = useCallback( () => {
		if ( doc ) {
			const ncl = occupants.filter( x => x !== doc );
			setOccupants( ncl );
			if ( doc.IsTemp ) {
				trackAction( "DelCoOccupant" );
			}
		}
	}, [ doc, occupants, trackAction ] );

	const onSubmit = useCallback( () => {
		updateEjari( occupants ).then( c => {
			if ( c != null ) {
				trackAction( "UpdateCoOccupant" );
				JQModal( "co_tenant_updated" ).show();
			}
		} );
	}, [ updateEjari, occupants, trackAction ] );
	const onConfirmClose = () => {
		props.history.go( -2 );
	};
	const onAddMore = () => {
		JQModal( "addMoreCoOccupant" ).show();
	};
	const bcs = useMemo( () => {
		if ( isPropertyMode ) return [ DashboardBCItem ];
		return [ DashboardBCItem, LeaseDetailsBCItem ];
	}, [] );
	if ( info?.ContractType == null )
		return <Redirect to={ "/mydld" }/>;
	const getString = tx.getString;
	return (
		<PageContent
			hideQLinks={ true }
			title={ getString( "manage_co_occupants" ) + tx.propertyTitle?.() }
		>
			<PageTitle title={ getString( "manage_co_occupants" ) } paths={ bcs }/>
			<React.Fragment>

				<AddCoOccupantPopup onNewCoOccupant={ onNewOccupant } occupants={ occupants }/>
				<OccupantList
					org={ oc } data={ occupants } onDelete={ onOCDel } onSubmit={ onSubmit }
					onAddMore={ onAddMore }/>
				{ occupants.length === 0 &&
					<AddForm onNewCoOccupant={ onNewOccupant } occupants={ occupants }/>
				}
			</React.Fragment>
			<Popup
				id={ "del-co_tenant" }
				title={ Strings.confirmation }
				showCloseButton={ true }
				clickOutsideToDismiss={ false }
				showIcon={ false }
				footer={ <>
					<button type="button" className="btn btn-grey" data-bs-dismiss="modal">
						{ Strings.cancel }
					</button>
					<button
						type="button" className="btn btn_1"
						onClick={ onDelConfirm }
						id="occupantViewDetail" data-bs-dismiss="modal">
						{ Strings.delete }
					</button>
				</> }
				noTitle={ false }>
				<div>
					<div className="cancel-icon">
						<i className="fa fa-times"/>
					</div>
					<p className="text-center">
						{ getString( "co_oc_del_confirm" ) }
					</p>
				</div>
			</Popup>
			<Popup
				id={ "co_tenant_updated" }
				title={ Strings.confirmation }
				showCloseButton={ true }
				clickOutsideToDismiss={ false }
				showIcon={ false }
				onDismiss={ onConfirmClose }
				footer={ <>
					<button type="button" className="btn btn_1" data-bs-dismiss="modal">
						{ Strings.close }
					</button>
				</> }
				noTitle={ false }>
				<div>
					<div>
						<div className="check-icon">
							<i className="fa fa-check"/>
						</div>
						<p className="text-center">
							{ getString( "co_oc_updated" ) }
						</p>
					</div>
				</div>
			</Popup>
		</PageContent>
	);
}

interface AddFormData {
	eid: string;
	dob: ServerDate;
	isPoD?: Lookup;
}

function useDataHolder<S extends Record<string, any>>( s: S | undefined, d: Dispatch<SetStateAction<S>> ): FormHolder<any, any> {
	return useMemo( () => {
		return {
			readValue<T, XT>( id: string ): NullableFormValue<T, XT> {
				if ( s && s[ id ] != null ) {
					return s[ id ];
				}
				return undefined;
			},

			writeValue<T, XT>( id: string, value: NullableFormValue<T, XT>, callback?: () => void ): NullableFormValue<T, XT> {
				d( { ...s, [ id ]: value } as S );
				callback?.();
				return value;
			}
		};
	}, [ s, d ] );
}

interface AddFromProps {
	onNewCoOccupant: ( occupant: CoOccupant ) => void;
	occupants: CoOccupant[];
}

function AddForm( props: AddFromProps ) {
	let { onNewCoOccupant, occupants } = props;
	const [ data, setData ] = useState<AddFormData>( {} as AddFormData );
	const [ valid, setValid ] = useState( false );
	const holder = useDataHolder( data, setData );
	const { dob, eid, isPoD } = data;
	const tx = useContext( COContext );
	const getString = tx.getString;
	useEffect( () => {
		if ( isPoD == null || StringUtil.isEmptyStringOrNull( dob ) || StringUtil.isEmptyStringOrNull( eid ) || eid?.length < 15 ) {
			setValid( false );
		} else {
			const sameId = occupants.find( x => x?.Person?.EmiratesId + "" === eid );
			setValid( sameId == null );
		}
	}, [ dob, eid, occupants, isPoD ] );
	const onVerify = useMemo( () =>
		() => {
			showLoading();
			const query = CoOccupantSearchInfo( eid, dob.asDate().asServerString() );
			EjariApi.searchCoOccupants( query )
			.then( occupant => {
				hideLoading();
				setData( {} as AddFormData );
				occupant.SpecialCase = isPoD?.Id === YES.Id;
				onNewCoOccupant( occupant );
			} )
			.catch( e => {
				hideLoading();
				showErrorMessage( e );
			} );
		}, [ dob, eid, isPoD, onNewCoOccupant ] );
	return (
		<>
			<div className="card mb-4 mt-4">
				<div className="card-header">
					<span>{ getString( "add_co_occupant" ) }</span>
				</div>
				<div className="card-body">
					<AddFormCore
						id={ "empty" }
						holder={ holder }
                        idContainerClass={ "col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 field-style form-group-icon" }
                        dobContainerClass={ "col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 field-style form-group-icon" }>
						<div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
                            <button
                                disabled={!valid}
                                onClick={onVerify}
                                type="button" className="btn btn_1 btn_style1"
                                id="btnVerify">{getString("add_co_occupant")}</button>
						</div>
					</AddFormCore>
				</div>
			</div>
		</>
	);
}

function AddCoOccupantPopup( props: AddFromProps ) {
	let { onNewCoOccupant, occupants } = props;
	const [ data, setData ] = useState<AddFormData>( {} as AddFormData );
	const [ valid, setValid ] = useState( false );
	const [ isLoading, setLoading ] = useState( false );
	const [ error, setError ] = useState<string | undefined>( undefined );
	const holder = useDataHolder( data, setData );
	const { dob, eid, isPoD } = data;
	const tx = useContext( COContext );
	const getString = tx.getString;
	useEffect( () => {
		if ( isPoD == null || StringUtil.isEmptyStringOrNull( dob ) || StringUtil.isEmptyStringOrNull( eid ) || eid?.length < 15 ) {
			setValid( false );
		} else {
			const sameId = occupants.find( x => x?.Person?.EmiratesId + "" === eid );
			setValid( sameId == null );
		}
	}, [ dob, eid, occupants, isPoD ] );
	const onVerify = useMemo( () =>
		() => {
			setError( undefined );
			setLoading( true );
			const query = CoOccupantSearchInfo( eid, dob.asDate().asServerString() );
			EjariApi.searchCoOccupants( query )
			.then( occupant => {
				setLoading( false );
				setData( {} as AddFormData );
				occupant.SpecialCase = isPoD?.Id === YES.Id;
				onNewCoOccupant( occupant );
				JQModal( "addMoreCoOccupant" ).hide();
			} )
			.catch( e => {
				setLoading( false );
				setError( getError( e ) );
			} );
		}, [ dob, eid, isPoD, onNewCoOccupant ] );
	return (
		<>
			<Popup
				id={ "addMoreCoOccupant" }
				title={ getString( "add_co_occupant" ) }
				showCloseButton={ true }
				clickOutsideToDismiss={ false }
				showIcon={ false }
				footer={ <>
					{ !isLoading &&
						<>
							<button
								type="button" className="btn btn-grey"
								data-bs-dismiss="modal">{ Strings.close }</button>
							<button
								disabled={ !valid }
								onClick={ onVerify }
								type="button" className="btn btn_1 btn_style1"
								id="btnVerify">{ getString( "add_co_occupant" ) }</button>
						</>
					}
					{ isLoading && <><SpinnerLoader/></> }
				</> }
				noTitle={ false }>
				<div>
					<AddFormCore
						id={ "popup" }
						idContainerClass={ "col-md-12 field-style form-group-icon mb-3" }
						dobContainerClass={ "col-md-12 field-style form-group-icon" }
						holder={ holder }/>

					{ error && <div className="alert alert-danger col-md-12">{ error }</div> }
				</div>
			</Popup>
		</>
	);
}

type FormCoreProps = {
	id: string;
	holder: FormHolder<any, any>;
	idContainerClass: string;
	dobContainerClass: string;
};

function AddFormCore( props: React.PropsWithChildren<FormCoreProps> ) {
	let { id, holder, idContainerClass, dobContainerClass, children } = props;
	const today = useRef( new Date() ).current;
	const onToggle = () => {
		JQModal( "emiratesIDInfoModal" ).toggle();
	};
	const tx = useContext( COContext );
	const getString = tx.getString;
	return <>
		<FormMandatory/>
		<EIDModal/>
		<div className="row">
			<div className={ idContainerClass }>
				<EidInputField
					containerClassName={ "form-group" }
					id={ "eid" }
					holder={ holder }
					required={ true }
					valueConverter={ eidConverter }
					label={ getString( "emirates_id_of_co_occupant" ) }
					placeHolder={ "784-XXXX-XXXXXX-X" }>
					<a onClick={ onToggle } className={ "login-input-info" }>
						<span className="sr-only">Information Icon</span>
						<span className="fa fa-info-circle info-icon-input"/></a>
				</EidInputField>
			</div>
			<div className={ dobContainerClass }>
				<DateInputField
					containerClassName={ "form-group position-relative" }
					required={ true }
					holder={ holder }
					label={ getString( "dob_of_co_occupant" ) }
					id={ "dob" }
					extraOpts={ {
						maxDate: today,
						yearRange: "-100:+0"
					} }
				/>
			</div>
			<>
				<RadioInputField
					required={ true }
					id={ "isPoD" }
					holder={ holder }
					label={ getString( "co_occupant_add_is_people_of_determination" ) }
					items={ YesNo }
					toIdentifier={ IdExtractor }/>
			</>
			{ children }
		</div>
	</>;
}

interface OccupantListProps {
	org: CoOccupant[];
	data: CoOccupant[];
	onDelete: ( oc: CoOccupant ) => void;
	onSubmit: () => void;
	onAddMore: () => void;
}

function OccupantList( props: OccupantListProps ) {
	let { org, data, onDelete, onSubmit, onAddMore } = props;
	const [ agreed, setAgreed ] = useState( false );
	const onCheckChange = ( event: ChangeEvent<HTMLInputElement> ) => {
		setAgreed( event.target.checked );
	};
	useEffect( () => {
		setAgreed( false );
	}, [ data ] );
	const showSubmit = data.length > 0 || org.length > 0;
	const hadOccupant = org.length !== 0 && data.length === 0;
	const canSubmit = ( agreed || hadOccupant ) && !_.isEqual( org, data );
	const hasData = data && data.length > 0;
	const cLabel = hasData ? " (" + data.length + ") " : "";
	const app = useContext( AppContext );

	const tx = useContext( COContext );
	const getString = tx.getString;
	let noMsg = getString( "no_co_occupants_yet" );
	if ( hadOccupant ) {
		if ( getString( "no_co_occupants_added" ) ) {
			noMsg = getString( "no_co_occupants_added" );
		}
	}
	return ( <>
			<div className="section-title justify-content-between">
				<h5>{ getString( "co_occupants" ) + cLabel } </h5>
				{ data.length > 0 && <button
					onClick={ onAddMore }
					type="button" className="btn btn_1 btn-sm">
					{ getString( "add_more_co_occupants" ) }
				</button>
				}
			</div>
			{ !app.isLoading && data.length === 0 &&
				<>
					<div className="alert alert-warning py-1 px-2">{ noMsg }</div>
				</>
			}
			{ data.length > 0 && <>
				<table className="table table-bordered table-striped font-size14" id="occupantList">
					<COHeader>
						<th style={ { width: 80 } } className="text-end">{ Strings.action }</th>
					</COHeader>
					<tbody>
					{ data.map( ( value, index ) =>
						<Row index={ index } data={ value } key={ index } onDelete={ onDelete }/> )
					}
					</tbody>
				</table>

				<div className="mt-4 mb-3">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" checked={agreed} onChange={onCheckChange} id="chk-agree" />
                        <label className="form-check-label" htmlFor={`chk-agree`}>
                            {Strings.co_oc_tc}
                        </label>
                    </div>
				</div>
			</> }
			{ showSubmit &&
				<button
					onClick={ onSubmit }
					disabled={ !canSubmit }
					className="btn btn_1 btn_style1 mt-2" type="submit" id="btnContinue">{ Strings.submit }
				</button>
			}
		</>
	);
}

function Row( props: { index: number, data: CoOccupant, onDelete: ( oc: CoOccupant ) => void } ) {
	let { data, index, onDelete } = props;
	const onDeleteX = () => {
		onDelete( data );
	};
	return <CORow index={ index } data={ data }>
		<td className="text-end">
			<button
				onClick={ onDeleteX }
				className="btn btn-sm btn-link font-size14 ps-0 pe-0">{ Strings.delete }
			</button>
		</td>
	</CORow>;
}
